import api from '../auth';
const slug = 'api/pugis/';

const PugiService = () => {
    const getPugis = () => {
        return api.get(slug).then((res) => res.data);
    };

    const getPugisLazy = (params) => {
        return api
            .get(slug, {
                params
            })
            .then((res) => res.data);
    };

    const getPugi = (id) => {
        return api.get(slug + `show/${id}/`).then((res) => res.data);
    };

    const deletePugi = (id) => {
        return api
            .delete(slug + `pugi/${id}/`)
            .then((res) => res.data)
            .catch((err) => {
                return err;
            });
    };

    const createPugi = (data) => {
        return api.post(slug, data).then((res) => res.data);
    };

    const updatePugi = (id, data) => {
        return api.put(slug + `pugi/${id}/`, data).then((res) => res.data);
    };

    const getOptions = () => {
        return api.options(slug).then((res) => res.data.actions.POST);
    };

    // custom action
    const copyPugi = (id) => {
        return api.post(slug + `copy/${id}/`).then((res) => res.data);
    };

    const startPugi = (data) => {
        return api.post(slug + `start/`, data).then((res) => res.data);
    };

    const endPugi = (data) => {
        return api.post(slug + `end/`, data).then((res) => res.data);
    };

    const pdfPugi = (id) => {
        return api
            .get(slug + `pdf/${id}/`, {
                responseType: 'blob'
            })
            .then((res) => {
                // Try to extract original filename from Content-Disposition header
                const disposition = res.headers['content-disposition'] || res.headers['Content-Disposition'];
                let filename = 'pugi.pdf';
                if (disposition) {
                    // RFC 5987 / standard filename patterns
                    const match = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(disposition);
                    if (match) {
                        filename = decodeURIComponent(match[1] || match[2]);
                    }
                }
                return { blob: res.data, filename };
            });
    };

    // exportExcel - export filtered results to Excel
    const exportExcel = (params) => {
        return api
            .get(slug + 'export-excel', {
                params,
                responseType: 'blob'
            })
            .then((res) => {
                let filename = res.headers['x-filename'] || 'pugi_export.xlsx';
                const disposition = res.headers['content-disposition'] || res.headers['Content-Disposition'];
                if (disposition) {
                    const match = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(disposition);
                    if (match) {
                        try {
                            filename = decodeURIComponent(match[1] || match[2]);
                        } catch (e) {
                            filename = match[1] || match[2];
                        }
                    }
                }
                return { blob: res.data, filename };
            });
    };

    // uploadSignatureImage
    const uploadSignatureImage = (id, data) => {
        return api
            .post(slug + `${id}/upload-signature-image`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then((res) => res.data);
    };

    // uploadSignatureImage
    const uploadImage = (id, data) => {
        return api
            .post(slug + `${id}/upload-image`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then((res) => res.data);
    };

    return {
        getPugis,
        getPugisLazy,
        getPugi,
        deletePugi,
        createPugi,
        updatePugi,
        getOptions,
        copyPugi,
        startPugi,
        endPugi,
        pdfPugi,
        exportExcel,
        uploadSignatureImage,
        uploadImage
    };
};

export default PugiService;
